import { Button } from '@/components';
import Link from 'next/link';
import { VEHICLE_BY_SLUG_QUERYResult } from 'sanity.types';

type VehicleHireProps = {
    vehicleHireProps: NonNullable<VEHICLE_BY_SLUG_QUERYResult>['vehicleHireProps'];
    vehicleId: string;
};

const VehiclePricingAndCTA = ({
    vehicleHireProps,
    vehicleId,
}: VehicleHireProps) => {
    if (!vehicleHireProps) return null;

    const { pricePerDay, pricePerWeek } = vehicleHireProps;

    const quoteLinkProps = {
        pathname: '/quote',
        query: { vehicleId },
    };

    return (
        <div className="flex justify-around md:justify-evenly items-center pr-2 flex-wrap md:flex-nowrap">
            <div className="flex flex-row w-full md:w-auto justify-around md:justify-start ">
                <div className="text-2xl md:text-3xl font-bold whitespace-nowrap flex items-center px-2 md:px-8">
                    £{pricePerDay}
                    <span className="text-2xl md:text-3xl font-bold ">
                        /day
                    </span>
                </div>
                <div className="text-2xl md:text-3xl font-bold md:border-l md:border-r border-gray-300 h-12 px-2 md:px-8 flex items-center">
                    £{pricePerWeek}
                    <span className="text-2xl md:text-3xl font-bold">
                        /week
                    </span>
                </div>
            </div>
            <Link href={quoteLinkProps} className="my-4">
                <Button label="Quote / Request booking" />
            </Link>
        </div>
    );
};

export default VehiclePricingAndCTA;
